import React, { Component } from "react";
import styled from "styled-components";

import { ds } from "js/core/models/dataService";
import { PresentationLibraryPane } from "js/editor/PresentationLibrary/PresentationLibraryPane";
import { BeautifulDialog } from "js/react/components/Dialogs/BaseDialog";

const PresentationLibraryContainer = styled.div`
  display: grid;
  height: 100%;
`;

const StyledDialog = styled(BeautifulDialog)`
    &&& {
        .MuiDialog-paper {
            height: 100% !important;
        }
    }
`;

const StyledPresentationLibraryPane = styled(PresentationLibraryPane)`
    &&& {
        overflow: auto;
        height: 100%;
    }
`;

export class PresentationLibraryDialog extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { onSelectedPresentation, closeDialog, maxWidth = false } = this.props;

        return (
            <StyledDialog onClose={closeDialog} maxWidth={maxWidth}>
                <PresentationLibraryContainer>
                    <StyledPresentationLibraryPane
                        showNavigationSidebar={false}
                        pane="recent"
                        workspaceId={ds.selection.presentation.getWorkspaceId()}
                        readOnly
                        showCloseIcon
                        isMyPresentationsOnly
                        onSelectedPresentation={presentationId => {
                            onSelectedPresentation(presentationId);
                            closeDialog();
                        }}
                        onCloseDialog={closeDialog}
                    />
                </PresentationLibraryContainer>
            </StyledDialog>
        );
    }
}
